import { render, staticRenderFns } from "./ProductosComponent.vue?vue&type=template&id=62d43a7a&scoped=true&"
import script from "./ProductosComponent.vue?vue&type=script&lang=js&"
export * from "./ProductosComponent.vue?vue&type=script&lang=js&"
import style0 from "./ProductosComponent.vue?vue&type=style&index=0&id=62d43a7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d43a7a",
  null
  
)

export default component.exports